import { Edit, ExpandMore } from '@mui/icons-material';
import { Fragment, memo, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import {
  Accordion,
  AccordionDetails,
  Grid,
  IconButton,
  Typography,
  useEventCallback,
} from '@mui/material';
import { useFormikContext } from 'formik';
import AccordionActualResidenceForm from './form';
import { FormActualResidenceVM } from 'practice/view-models/pratice-actual-residence';
import {
  PracticeEditResidence,
  TableDomesticPartnershipVM,
  TableNewFamilySubjectsVM,
} from 'practice/view-models/practice-edit-residence';
import { ResidenceID } from 'practice/constants/id-practice-edit-residence';
import TableNewFamily from '../../modal-family/accordion-new-family-subjects/table-new-family';
import TableDomestic from '../../modal-domestic-partnership/table-domestic-partnership/table-domestic';
import { TypeRegister } from 'practice/constants/type-register';
// import NewFamilyResidence from './new-residence-family';

interface AccordionActualResidenceProps {
  disabled?: boolean;
  disabledAll?: boolean;
  onEdit: () => void;
  ForPracticeTemporary?: boolean;
  typeRegister?: string;
  yearId?: string;
  progressive?: string;
}

const AccordionActualResidenceComponent = ({
  disabled,
  onEdit,
  ForPracticeTemporary,
  disabledAll,
  typeRegister,
}: // yearId,
// progressive,
AccordionActualResidenceProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<PracticeEditResidence>();

  const onChange = useEventCallback(
    (
      key: keyof FormActualResidenceVM,
      value: FormActualResidenceVM[keyof FormActualResidenceVM]
    ) => {
      formContext.setFieldValue('residence', {
        ...(formContext.values.residence || {}),
        [key]: value,
      });
    }
  );

  const disabledEdit = useMemo(() => {
    if (disabledAll) {
      // disabilitato da messi
      return true;
    }

    if (
      formContext.values.typeResidence === ResidenceID.new ||
      formContext.values.typeResidence === ResidenceID.family ||
      formContext.values.typeResidence === ResidenceID.domesticPartnership
    ) {
      return false;
    }

    // se lo stato è allFamily e ci sono dati salvati non disabilitare

    if (formContext.values.typeResidence !== ResidenceID.allFamily) {
      return true;
    }

    if (
      !formContext.values.residence?.checkedResidence &&
      formContext.values.residence?.italian?.municipality?.description
    ) {
      // presente italia
      return false;
    }

    if (
      formContext.values.residence?.checkedResidence &&
      formContext.values.residence?.foreign?.foreignState?.value
    ) {
      // presente estero
      return false;
    }

    return true;
  }, [formContext.values.typeResidence, formContext.values.residence]);

  const onChangeTableNewFamily = useEventCallback((newTable: TableNewFamilySubjectsVM) => {
    formContext.setFieldValue('tableNewFamilySubjects', newTable);
  });

  const onChangeTableDomesticPartnership = useEventCallback((table: TableDomesticPartnershipVM) => {
    formContext.setFieldValue('tableDomesticPartnership', table);
  });

  const titleAccordion = useMemo(() => {
    switch (formContext.values.typeResidence) {
      case ResidenceID.allFamily:
      case ResidenceID.new:
        return 'Nuova residenza';
      case ResidenceID.family:
        return typeRegister === TypeRegister.Emigration
          ? 'Residenza in famiglia AIRE'
          : 'Residenza in famiglia già esistente';
      case ResidenceID.domesticPartnership:
        return 'Residenza in convivenza';
      default:
        return 'Residenza';
    }
  }, [formContext.values.typeResidence]);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-residence-practice-content"
          id="panel-reisdence-practice-header"
          expandIcon={<ExpandMore />}
        >
          <Typography style={{ width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              {titleAccordion}
              <IconButton
                aria-label="Modifica elemento"
                aria-haspopup="true"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();

                  onEdit();
                }}
                style={{
                  padding: '4px',
                }}
                disabled={disabledEdit}
              >
                <Edit />
              </IconButton>
            </div>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Fragment>
            <AccordionActualResidenceForm
              ForPracticeTemporary={ForPracticeTemporary}
              values={formContext.values.residence as FormActualResidenceVM}
              onChange={onChange}
              disabled={disabled}
              isEmigr={typeRegister === TypeRegister.Emigration}
              typeResidence={formContext.values.typeResidence}
            />
            <Grid container spacing={2}>
              {/* {formContext.values.typeResidence === ResidenceID.new &&
              formContext.values.residence ? (
                <NewFamilyResidence
                  typeRegister={typeRegister}
                  progressive={progressive}
                  yearId={yearId}
                />
              ) : undefined} */}
              {formContext.values.typeResidence === ResidenceID.family &&
              (formContext.values.tableNewFamilySubjects?.body || [])?.length > 0 ? (
                <TableNewFamily
                  disabled
                  tableNewFamilySubjects={formContext.values.tableNewFamilySubjects}
                  onChangeTableNewFamily={onChangeTableNewFamily}
                  noControl
                />
              ) : undefined}
              {formContext.values.typeResidence === ResidenceID.domesticPartnership &&
              (formContext.values.tableDomesticPartnership?.body || [])?.length > 0 ? (
                <TableDomestic
                  disabled
                  tableDomesticPartnership={formContext.values.tableDomesticPartnership}
                  onChangeTableDomesticPartnership={onChangeTableDomesticPartnership}
                />
              ) : undefined}
            </Grid>
          </Fragment>
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionActualResidenceComponent.displayName = 'Accordion Actual Residence';

const AccordionActualResidence = memo(AccordionActualResidenceComponent);

export default AccordionActualResidence;
